<template>
    <fieldset class="membership">
        <my-radio-group
            name="member"
            label="Are you a member?"
            info="Membership gets you free admission to the museum, and at some levels covers your guests as well!"
            :radio-options="membershipRadioOptions"
            @change="membershipChanged"
        />
        <my-input
            label=""
        >
            <template v-slot:custom>
                <p v-if="myIsMember">
                    We will confirm membership status and level when you arrive.
                </p>
                <a v-else href="/join">
                    Learn more about Gilley membership.
                </a>
            </template>
        </my-input>
    </fieldset>
</template>

<script>
import MyInput from '../../_components/form/MyInput';
import MyRadioGroup from '../../_components/form/MyRadioGroup';

export default {
    components: {
        MyInput,
        MyRadioGroup,
    },
    props: {
        isMember: {
            type: Boolean,
        },
    },
    data() {
        return {
            membershipRadioOptions: [],
            myIsMember: null,
        };
    },
    methods: {
        membershipChanged($evt) {
            this.myIsMember = $evt === 'true';
            this.$emit('update', this.myIsMember);
        },
        touch() {
            // this.$v.$touch();
        },
    },
    mounted() {
        this.membershipRadioOptions = [
            { value: true, label: 'Yes', checked: this.isMember },
            { value: false, label: 'No', checked: !this.isMember },
        ];
    },
}
</script>

<style>
.reservationForm fieldset.membership {
    width: 43em;
}
fieldset.membership a {
    color: rgb(127, 22, 28);
}
fieldset.membership a:hover {
    color: rgb(213, 128, 38);
}
</style>
